module.exports = __webpack_public_path__ + "assets/4-day-in-life-customer-success-manager.9ae1c326.png";